import {
  FacebookAuthProvider,
  GoogleAuthProvider,
  signInWithPopup,
} from "firebase/auth";
import { Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { Button, Card, Col, Modal, Row } from "react-bootstrap";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import Swal from "sweetalert2";
import * as yup from "yup";
import api from "../../apiClient";
import { auth } from "../../firebase/firebaseConfig";
import ActivataionAccount from "./ActivataionAccount";
import SocialButtons from "./sessions/SocialButtons";
import TextField from "./sessions/TextField";

const CandiSignup = () => {
  const navigate = useNavigate();
  const initialFormValues = {
    userName: "",
    userEmail: "",
    appliedDate: new Date().toISOString(),
    password: "",
    confirmPassword: "",
    referredBy: "",   // ✅ new field
    agreeToTermsAndCondition: false,
    userRole: "Candidate", // Setting userRole as 'candidate'
  };

  const [formValues, setFormValues] = useState(initialFormValues);
  const [disableFormFields, setDisableFormFields] = useState(false);
  const [otpValue, setOtpValue] = useState("");
  const [enterOtpValue, setEnterOtpValue] = useState("");
  const [otpVerified, setOtpVerified] = useState(false);
  const [showOTPModal, setShowOTPModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [emailExistsError, setEmailExistsError] = useState(false);
  const [passwordCriteriaError, setPasswordCriteriaError] = useState(false);
  const [passwordMatchError, setPasswordMatchError] = useState(false);
  const [agreeToTermsAndConditionByCheck, setAgreeToTermsAndConditionByCheck] =
    useState(false);
  const [showActivationModal, setShowActivationModal] = useState(false); // State to control modal visibility
  const [userEmail, setUserEmail] = useState(""); // State to hold user email
  const [userExistsMesg, setUserExistsMsg] = useState("");
  const [userDeactivtaeErrorMsg, setUserDeactivateErrorMsg] = useState("");
  const [loading, setLoading] = useState(false); // State to manage loading
  const [showPassword, setShowPassword] = useState(false); // Add state for password visibility
  const [showConfirmPassword, setShowConfirmPassword] = useState(false); // Add state for re-password visibility

  
  useEffect(() => {
    const storedFormValues =
      JSON.parse(localStorage.getItem("candidateRegistrationForm")) ||
      formValues;
    setFormValues(storedFormValues);
  }, []);

  useEffect(() => {
    localStorage.setItem(
      "candidateRegistrationForm",
      JSON.stringify(formValues)
    );
  }, [formValues]);

  useEffect(() => {
    const storedFormValues =
      JSON.parse(localStorage.getItem("candidateRegistrationForm")) ||
      initialFormValues;
    if (
      Object.keys(formValues).length === 0 &&
      formValues.constructor === Object
    ) {
      setFormValues(storedFormValues);
    }
  }, []);
  useEffect(() => {
    // Clear localStorage when the component unmounts
    return () => {
      localStorage.removeItem("candidateRegistrationForm");
    };
  }, []);

  const handleSubmit = async (values, { setSubmitting }) => {
    // const checkUserResponse = await api.checkUser(values.userEmail);
    // console.log("User  Check Response:", checkUserResponse.data);

    // if (checkUserResponse.status === 200) {
    //   if (checkUserResponse.data.deActivate === true) {
    //     setUserEmail(values.userEmail);
    //     setUserDeactivateErrorMsg(
    //       <span>
    //         Your email already exists. Please{' '}
    //         <Link
    //           to="#"
    //           onClick={(e) => {
    //             e.preventDefault(); // Prevent default link behavior
    //             localStorage.setItem('redirectAfterLogin', 'hr-sign-in');
    //             setShowActivationModal(true); // Show the activation modal
    //           }}
    //         >
    //           Activate Your Account
    //         </Link>{' '}
    //         to log in to your account.
    //       </span>
    //     )
    //   }
    //   else {
    //     setUserExistsMsg(
    //       <span>
    //         Your email already exists. Please{' '}
    //         <Link to="/signin" state={{ userRole: 'Candidate' }}>
    //           click here
    //         </Link>{' '}
    //         to log in to your account.
    //       </span>
    //     );;
    //   }
    // }

    setSubmitting(true);

    // Validate password criteria
    if (!validatePassword(values)) {
      setSubmitting(false);
      return;
    }

    // Ensure userRole is included in the form values
    const userData = {
      ...values,
      userRole: "Candidate", // Ensure userRole is set to 'candidate'
    };

    try {
      const response = await api.saveUser(userData);

      if (
        !response.data ||
        response.data === "undefined" ||
        response.data === ""
      ) {
        setEmailExistsError(true);
        setSubmitting(false);
        return;
      } else {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "candidate_signup",
          user_id: response.data.userId || "unknown", // update this as needed
          method: "email",
        });
        // Show SweetAlert for registration success
        let additionalText = "";

        additionalText = "Welcome!" + "\n" + "Click here for login";
        Swal.fire({
          icon: "success",
          title: "Registration Successful!",
          text:
            "Your registration has been successful." +
            (additionalText ? "\n" + additionalText : ""),
          confirmButtonText: "OK",
        }).then((result) => {
          if (result.isConfirmed) {
            navigate("/signin", { state: { userRole: "Candidate" } });
          }
        });
      }
    } catch (error) {
      console.error("Error registering User:", error);
      setErrorMessage("Error registering User. Please try again later.");
    } finally {
      setSubmitting(false);
    }
  };

  const validatePassword = (values) => {
    const { password, confirmPassword } = values;
    const isValidPassword =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+])[A-Za-z\d!@#$%^&*()_+]{8,20}$/.test(
        password
      );
    const passwordsMatch = password === confirmPassword;

    if (!isValidPassword) {
      setPasswordCriteriaError(true);
      return false;
    }

    if (!passwordsMatch) {
      setPasswordMatchError(true);
      return false;
    }

    return true;
  };

  // Validation schema using Yup
  const validationSchema = yup.object().shape({
    userName: yup.string().required("Name is required"),
    userEmail: yup
      .string()
      .email("Invalid email")
      .required("Email is required"),
    phone: yup.string().required("Phone number is required"),
    password: yup
      .string()
      .required("Password is required")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+])[A-Za-z\d!@#$%^&*()_+]{8,20}$/,
        "Invalid password match..."
      ),

    confirmPassword: yup
      .string()
      .required("Repeat Password is required")
      .oneOf([yup.ref("password")], "Passwords must match"),
    agreeToTermsAndCondition: yup
      .bool()
      .oneOf([true], "You must agree to validate your email"),
  });

  // Function to send OTP
  const sendOTP = async (email) => {
    if (!email || email === "undefined" || email === "") {
      // alert("Please enter an email first.");
      toast.error("Please enter an email first."); // Display error message --->   npm install react-toastify

      setDisableFormFields(false);

      return; // Exit the function early
    } else {
      console.log(email);
      const checkUserResponse = await api.checkUser(email);
      console.log("User  Check Response:", checkUserResponse.data);
      if (checkUserResponse.status === 200) {
        if (checkUserResponse.data.deActivate === true) {
          setUserEmail(email);
          setUserDeactivateErrorMsg(
            <span>
              Your email already exists. Please{" "}
              <Link
                to="#"
                onClick={(e) => {
                  e.preventDefault(); // Prevent default link behavior
                  localStorage.setItem(
                    "redirectAfterLogin",
                    "candidate-signup"
                  );
                  setShowActivationModal(true); // Show the activation modal
                }}
              >
                Activate Your Account
              </Link>{" "}
              to log in to your account.
            </span>
          );
        } else if (
          checkUserResponse.data.userName !== null &&
          checkUserResponse.data.password !== null
        ) {
          setUserExistsMsg(
            <span>
              Your email already exists. Please{" "}
              <Link to="/signin" state={{ userRole: "Candidate" }}>
                click here
              </Link>{" "}
              to log in to your account.
            </span>
          );
        } else {
          setUserExistsMsg(
            <span>
              Your email already exists.
              <br />
              But data is not set....
              <br />
              <Button onClick={() => handleUpdateData(email)}>
                Update Data
              </Button>
            </span>
          );
        }
      } else {
        let loadingPopup;
        try {
          // Show loading message using SweetAlert
          loadingPopup = Swal.fire({
            title: "Verifing your email...",
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });
          const response = await api.validateUserEmail(email);
          setOtpValue(response.data);
          setShowOTPModal(true);
          if (response.data) {
            Swal.close();
            toast.success("varification code sent successfully!");
          }
        } catch (error) {
          console.error("Error sending OTP:", error);
          if (loadingPopup) {
            Swal.close();
          }
          setErrorMessage(
            "Error sending varification code. Please try again later."
          );
        }
      }
    }
  };
  const handleUpdateData = async (email) => {
    setEmailExistsError(true);
    setUserExistsMsg("");

    try {
      toast.info("Sending varification code for you, wait for some time...");
      const response = await api.validateUserEmail(email);

      if (response?.data) {
        setOtpValue(response.data);
        setShowOTPModal(true);
        toast.success("varification code sent successfully!");
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
      setErrorMessage(
        "Error sending varification code. Please try again later."
      );
    }
  };

  // Function to handle OTP verification
  const handleOTPVerification = () => {
    if (otpValue == enterOtpValue) {
      setOtpVerified(true);
      setShowOTPModal(false);
      // Proceed to submit form data after OTP verification
      setSuccessMessage("Email verified successfully!");
    } else {
      setOtpVerified(false);
      setErrorMessage("Invalid varification code. Please try again.");
    }
  };

  // Function to update user data (in case of email already exists)
  const updateUserData = async (values) => {
    try {
      const response = await api.updateUserData(values);

      if (response.data) {
        Swal.fire({
          icon: "success",
          title: "Update Successful!",
          text: "Your data has been updated successful.",
          confirmButtonText: "OK",
        }).then((result) => {
          if (result.isConfirmed) {
            navigate("/signin");
          }
        });
      } else {
        setErrorMessage(true);
        return;
      }
    } catch (error) {
      console.error("Error updating user data:", error);
      alert("Data not updated");
    }
  };

  // Function to show the password criteria error
  const showErrorToast = () => {
    toast.error(
      <div
        className="alert alert-info"
        style={{ maxWidth: "400px", margin: "20px auto", borderRadius: "5px" }}
      >
        <h5>Password Guidelines</h5>
        <ul className="list-unstyled">
          <li>• At least one number</li>
          <li>• One special character</li>
          <li>• One uppercase letter</li>
          <li>• One lowercase letter</li>
          <li>• Between 8 to 20 characters</li>
        </ul>
      </div>
    );
  };

  // Effect to show the toast when the error is true
  React.useEffect(() => {
    if (passwordCriteriaError) {
      showErrorToast();
    }
  }, [passwordCriteriaError]);

  // Google Sign-In Handle
  const signInWithGoogle = async () => {
    const provider = new GoogleAuthProvider();
    provider.setCustomParameters({ prompt: "select_account" });

    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      const userEmail = user.email;

      // Check if the user exists in the backend
      const response = await api.checkUserWithToken(userEmail);
      const existingUser = response.data.user;
      const token = response.data.token;
      setLoading(true);
      if (existingUser && token) {
        console.log("Existing User ID:", existingUser.userId);
        console.log("Existing User ID token:", token);
        console.log("details existing user: ", existingUser);
        // Store token in localStorage
        localStorage.setItem("token", token);
        localStorage.setItem("user", JSON.stringify(existingUser));

        // console.log( JSON.stringify(existingUser))
        // Store user data and token in cookies
        const domain =
          window.location.hostname === "localhost" ? "localhost" : "jobbox.one";
        document.cookie = `user=${JSON.stringify(
          existingUser
        )}; path=/; domain=${domain}; secure; samesite=strict;`;
        document.cookie = `token=${token}; path=/; domain=${domain}; secure; samesite=strict;`;

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "candidate_login",
          user_id: existingUser.userId || "unknown",
          method: "google",
        });

        // Navigate to dashboard
        Swal.fire({
          icon: "success",
          title: "Welcome Back!",
          text: "You are already registered. Click here to go to your dashboard.",
          confirmButtonText: "OK",
        }).then((result) => {
          if (result.isConfirmed) {
            navigate("/candidate-dashboard", {
              state: {
                userId: existingUser.userId,
                userName: existingUser.userName,
              },
            });
          }
        });
      } else {
        console.log("User not found. Registering new user...");
        setLoading(true); // Start loading
        // Handle new user registration
        const randomPassword = Math.random().toString(36).slice(-8);
        const newUser = {
          userName: user.displayName, // Ensure userName is set
          userEmail: userEmail,
          password: randomPassword,
          userRole: "Candidate",
           appliedDate: new Date().toISOString()
        };

        // Save new user to the backend
        const saveResponse = await api.saveUser(newUser);

        if (saveResponse.status === 201) {
          const response = await api.checkUserWithToken(userEmail);
          const registeredUser = response.data.user;
          const token = response.data.token;

          if (registeredUser && token) {
            localStorage.setItem("token", token);
            localStorage.setItem("user", JSON.stringify(registeredUser));

            const domain =
              window.location.hostname === "localhost"
                ? "localhost"
                : "jobbox.one";
            document.cookie = `user=${JSON.stringify(
              registeredUser
            )}; path=/; domain=${domain}; secure; samesite=strict;`;
            document.cookie = `token=${token}; path=/; domain=${domain}; secure; samesite=strict;`;

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: "candidate_signup",
              user_id: registeredUser.userId || "unknown",
              method: "google",
            });
            Swal.fire({
              icon: "success",
              title: "Registration Successful!",
              text: "Your account has been created. Click here to go to your dashboard.",
              confirmButtonText: "OK",
            }).then((result) => {
              if (result.isConfirmed) {
                navigate("/candidate-dashboard", {
                  state: {
                    userId: registeredUser.userId,
                    userName: registeredUser.userName,
                  },
                });
              }
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Registration Failed!",
              text: "An error occurred while creating your account. Please try again.",
              confirmButtonText: "OK",
            });
          }
        }
      }
    } catch (error) {
      console.error("Google Sign-In error:", error);
      setErrorMessage("Error signing in with Google.");
    }
  };

  const signInWithFacebook = async () => {
    const provider = new FacebookAuthProvider();

    try {
      // Show Facebook login popup
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      const userEmail = user.email;

      // Check if the user already exists in the backend
      const response = await api.checkUser(userEmail);
      const existingUser = response.data;

      if (existingUser) {
        const userId = existingUser.userId;
        console.log("Existing User ID:", userId);

        // Show SweetAlert for existing user
        Swal.fire({
          icon: "success",
          title: "Welcome Back!",
          text: "You are already registered. Click here to go dashboard.",
          confirmButtonText: "OK",
        }).then((result) => {
          if (result.isConfirmed) {
            navigate("/candidate-dashboard", {
              state: { userRole: "Candidate", userId: userId },
            });
          }
        });
      } else {
        // User does not exist, create a new user
        const randomPassword = Math.random().toString(36).slice(-8);
        const newUser = {
          userName: user.displayName, // Use Facebook user display name
          userEmail: userEmail,
          password: randomPassword,
          userRole: "Candidate",
           appliedDate: new Date().toISOString()
        };

        // Save new user to the backend
        const saveResponse = await api.saveUser(newUser);

        // Log the entire save response to see what is returned from the backend
        console.log("Response from saveUser:", saveResponse.data);

        // Check if the user is successfully created
        if (saveResponse.data) {
          Swal.fire({
            icon: "success",
            title: "Registration Successful!",
            text: "Your registration has been successful. Welcome! Click here to set password.",
            confirmButtonText: "OK",
          }).then((result) => {
            if (result.isConfirmed) {
              navigate("/forgetpassword", { state: { userRole: "Candidate" } });
            }
          });
        }
      }
    } catch (error) {
      // Log detailed error information
      console.error("Facebook Sign-In error:", error);
      console.error(
        "Detailed Error Info:",
        error.response ? error.response.data : error.message
      );
      setErrorMessage("Error signing in with Facebook. Please try again.");
    }
  };
  const homeUrl =
    window.location.hostname === "localhost"
      ? "http://localhost:3001"
      : "https://jobbox.one";
  return (
<div
  className="auth-layout-wrap"
  style={{
    backgroundImage:
      'linear-gradient(rgba(5,15,35,0.72), rgba(0,10,30,0.78)), url("/candidate.jpg")',
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    minHeight: "100vh",
  }}
>
  <div className="auth-content d-flex align-items-center justify-content-center min-vh-100">
    <Card className="o-hidden card bg-transparent border-0 shadow-none">
      <Row>
        {/* LEFT SIDE */}
        <Col md={6} className="text-center auth-cover">
          <div className="ps-3 auth-right">
            <div className="auth-logo text-center mt-4">
              <a href={homeUrl}>
                <img
                  src="/jb_logo.png"
                  alt="jobbox_logo"
                  style={{ maxWidth: "180px" }}
                />
              </a>
            </div>

            <div className="w-100 h-100 justify-content-center d-flex flex-column">
              <p
                style={{
                  color: "#ffffff",
                  fontSize: "18px",
                  fontWeight: "600",
                  textShadow: "0 0 8px rgba(0,180,255,0.5)",
                }}
              >
                Already have an account? Login
              </p>

              {loading ? (
                <div style={{ color: "#fff" }}>Loading...</div>
              ) : (
                <SocialButtons
                  isLogin={true}
                  routeUrl="/signin"
                  googleHandler={signInWithGoogle}
                  facebookHandler={signInWithFacebook}
                />
              )}
            </div>
          </div>
        </Col>

        {/* RIGHT SIDE */}
        <Col md={6}>
          <div className="p-4">
            <h1
              className="mb-3 text-18 fw-bold text-center"
              style={{
                color: "#ffffff",
                fontSize: "28px",
                textShadow: "0 0 10px rgba(0,180,255,0.6)",
              }}
            >
              Candidate Registration Form
            </h1>

            <Formik
              initialValues={formValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
              enableReinitialize
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                isSubmitting,
              }) => (
                <Form>
                  <TextField
                    type="text"
                    name="userName"
                    label={
                      <>
                        Your name <span style={{ color: "red" }}>*</span>
                      </>
                    }
                    required
                    placeholder="Enter your name"
                    value={values.userName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    helperText={touched.userName && errors.userName}
                    error={touched.userName && Boolean(errors.userName)}
                    disabled={disableFormFields}
                    fullWidth
                    InputLabelProps={{ style: { color: "#fff" } }}
                    InputProps={{
                      style: {
                        color: "#fff",
                        background: "rgba(255,255,255,0.08)",
                        borderRadius: "10px",
                      },
                    }}
                  />

                  <TextField
                    type="email"
                    name="userEmail"
                    label={
                      <>
                        Your Email <span style={{ color: "red" }}>*</span>
                      </>
                    }
                    required
                    placeholder="Enter your email"
                    value={values.userEmail}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    helperText={touched.userEmail && errors.userEmail}
                    error={touched.userEmail && Boolean(errors.userEmail)}
                    disabled={disableFormFields || emailExistsError}
                    fullWidth
                    InputLabelProps={{ style: { color: "#fff" } }}
                    InputProps={{
                      style: {
                        color: "#fff",
                        background: "rgba(255,255,255,0.08)",
                        borderRadius: "10px",
                      },
                    }}
                  />

                  <TextField
                    type="text"
                    name="phone"
                    label={
                      <>
                        Phone Number <span style={{ color: "red" }}>*</span>
                      </>
                    }
                    required
                    placeholder="Enter your phone number"
                    value={values.phone}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    helperText={touched.phone && errors.phone}
                    error={touched.phone && Boolean(errors.phone)}
                    disabled={disableFormFields}
                    fullWidth
                    InputLabelProps={{ style: { color: "#fff" } }}
                    InputProps={{
                      style: {
                        color: "#fff",
                        background: "rgba(255,255,255,0.08)",
                        borderRadius: "10px",
                      },
                    }}
                  />

                  {/* PASSWORD */}
                  <div className="position-relative">
                    <TextField
                      type={showPassword ? "text" : "password"}
                      name="password"
                      label={
                        <>
                          Password <span style={{ color: "red" }}>*</span>
                        </>
                      }
                      required
                      placeholder="Enter your password"
                      value={values.password}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      helperText={touched.password && errors.password}
                      error={touched.password && Boolean(errors.password)}
                      disabled={disableFormFields}
                      fullWidth
                      InputLabelProps={{ style: { color: "#fff" } }}
                      InputProps={{
                        style: {
                          color: "#fff",
                          background: "rgba(255,255,255,0.08)",
                          borderRadius: "10px",
                        },
                      }}
                    />

                    <button
                      type="button"
                      className="btn btn-link position-absolute"
                      style={{
                        right: "18px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        padding: "0",
                        color: "#9fdcff",
                        background: "transparent",
                        border: "none",
                        cursor: "pointer",
                        zIndex: "1",
                      }}
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? (
                        <FaEyeSlash size={18} />
                      ) : (
                        <FaEye size={18} />
                      )}
                    </button>
                  </div>

                  {/* CONFIRM PASSWORD */}
                  <div className="position-relative">
                    <TextField
                      type={
                        showConfirmPassword ? "text" : "password"
                      }
                      name="confirmPassword"
                      label={
                        <>
                          Confirm Password{" "}
                          <span style={{ color: "red" }}>*</span>
                        </>
                      }
                      required
                      placeholder="Re-enter your password"
                      value={values.confirmPassword}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      helperText={
                        touched.confirmPassword &&
                        errors.confirmPassword
                      }
                      error={
                        touched.confirmPassword &&
                        Boolean(errors.confirmPassword)
                      }
                      disabled={disableFormFields}
                      fullWidth
                      InputLabelProps={{ style: { color: "#fff" } }}
                      InputProps={{
                        style: {
                          color: "#fff",
                          background: "rgba(255,255,255,0.08)",
                          borderRadius: "10px",
                        },
                      }}
                    />

                    <button
                      type="button"
                      className="btn btn-link position-absolute"
                      style={{
                        right: "18px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        padding: "0",
                        color: "#9fdcff",
                        background: "transparent",
                        border: "none",
                        cursor: "pointer",
                        zIndex: "1",
                      }}
                      onClick={() =>
                        setShowConfirmPassword(
                          !showConfirmPassword
                        )
                      }
                    >
                      {showConfirmPassword ? (
                        <FaEyeSlash size={18} />
                      ) : (
                        <FaEye size={18} />
                      )}
                    </button>
                  </div>

                  {passwordMatchError && (
                    <p
                      style={{
                        color: "red",
                        fontSize: "0.875rem",
                        marginTop: "0.25rem",
                      }}
                    >
                      Password did not match, please try again...
                    </p>
                  )}

                  <TextField
                    type="text"
                    name="referredBy"
                    label="Referred By"
                    placeholder="Enter referral code or name (if any)"
                    value={values.referredBy}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    helperText={
                      touched.referredBy && errors.referredBy
                    }
                    error={
                      touched.referredBy &&
                      Boolean(errors.referredBy)
                    }
                    disabled={disableFormFields}
                    fullWidth
                    InputLabelProps={{ style: { color: "#fff" } }}
                    InputProps={{
                      style: {
                        color: "#fff",
                        background: "rgba(255,255,255,0.08)",
                        borderRadius: "10px",
                      },
                    }}
                  />

                  {!otpVerified && (
                    <div className="d-flex justify-content-center">
                      <Button
                        disabled={
                          disableFormFields || otpVerified
                        }
                        className="mt-2"
                        onClick={() => {
                          setDisableFormFields(true);
                          sendOTP(values.userEmail);
                        }}
                      >
                        Validate my email
                      </Button>
                    </div>
                  )}

                  {successMessage && (
                    <p className="success-message">
                      {successMessage}
                    </p>
                  )}

                  {userDeactivtaeErrorMsg && (
                    <div className="text-danger">
                      {userDeactivtaeErrorMsg}
                    </div>
                  )}

                  <div style={{ color: "#fff" }}>
                    <Field
                      type="checkbox"
                      name="agreeToTermsAndCondition"
                      id="agreeToTermsAndCondition"
                      checked={
                        values.agreeToTermsAndCondition
                      }
                      onChange={(e) => {
                        handleChange(e);
                        setAgreeToTermsAndConditionByCheck(
                          true
                        );
                      }}
                      style={{
                        marginRight: "10px",
                      }}
                    />

                    <label>
                      I agree to the{" "}
                      <Link
                        to={`${homeUrl}/TermsOfService.html`}
                        target="_blank"
                        style={{
                          textDecoration: "underline",
                          color: "#00b4ff",
                        }}
                      >
                        Terms and Conditions
                      </Link>{" "}
                      of the website
                    </label>
                  </div>

                  {emailExistsError && (
                    <div>
                      <Button
                        disabled={
                          !otpVerified ||
                          !agreeToTermsAndConditionByCheck
                        }
                        onClick={() => updateUserData(values)}
                      >
                        Update Your Data
                      </Button>
                    </div>
                  )}

                  {errorMessage && (
                    <div className="text-danger">
                      {errorMessage}
                    </div>
                  )}

                  <div className="d-flex justify-content-center">
                    <Button
                      type="submit"
                      className="btn btn-primary w-50 my-1 btn-rounded mt-3"
                      disabled={
                        !otpVerified ||
                        isSubmitting ||
                        emailExistsError ||
                        !agreeToTermsAndConditionByCheck
                      }
                    >
                      {isSubmitting
                        ? "Registering..."
                        : "Register"}
                    </Button>
                  </div>

                  {userExistsMesg && (
                    <div className="text-danger text-center">
                      {userExistsMesg}
                    </div>
                  )}
                </Form>
              )}
            </Formik>
          </div>
        </Col>
      </Row>

      {/* OTP MODAL */}
      <Modal
        show={showOTPModal}
        onHide={() => setShowOTPModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>OTP Verification</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>
            An OTP has been sent to your email. Please enter it
            below:
          </p>

          <TextField
            type="text"
            name="otp"
            placeholder="Enter verification code"
            value={enterOtpValue}
            onChange={(e) =>
              setEnterOtpValue(e.target.value)
            }
          />
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowOTPModal(false)}
          >
            Cancel
          </Button>

          <Button
            variant="primary"
            onClick={handleOTPVerification}
          >
            Verify Code
          </Button>
        </Modal.Footer>
      </Modal>

      <div>
        {showActivationModal && (
          <ActivataionAccount
            userEmail={userEmail}
            onClose={() =>
              setShowActivationModal(false)
            }
          />
        )}

        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
        />
      </div>
    </Card>
  </div>
</div>
  );
};

export default CandiSignup;
